module.exports = __webpack_public_path__ + "static/media/icon_audio_headphones_on.2d4b280b.svg";